<template>
    <tr  @click="onClick(quote.uuid)" :class="{highlightRow: quote.uuid === selectedRow}">
      <td data-label="Reference #">
        <strong>
          {{ quote.reference }}
        </strong> <br/>
        <span class="text-muted" v-if="quote.DiscountApprover && quote.DiscountApprover.fullName"><i class="far fa-user" /> {{ quote.DiscountApprover.fullName }}</span>
        <span :class="assignedStatus.class">{{ assignedStatus.text }}</span>
        <span :class="status.class">{{ status.text }}</span>
        <br/>
        <span class="text-muted">{{ completedDate }}</span>
      </td>
      <td data-label="Property Address">
        {{ quote.propertyAddress }}
      </td>
      <td data-label="Report Type">
        {{ quote.quoteName }}
      </td>
      <td data-label="Requested">
        {{ quote.ocManagerName }} <br/>
        <span v-if="quote.Company && quote.Company.name">({{ quote.Company.name }})<br/></span>
        <span class="text-muted">{{ dateRequested }}</span>
      </td>
      <td data-label="Sent">
        <template v-if="quote.EmailSender && quote.sentDate">
          {{ quote.EmailSender.fullName }} <br/>
          <span class="text-muted">{{ dateSent }}</span>
        </template>
        <template v-else>
          N/A
        </template>
      </td>
      <td data-label="Date Accepted">
        <template v-if="quote.acceptedDate">
          <span class="text-muted">{{ dateAccepted }}</span>
        </template>
      </td>
      <td data-label="Assigned To">
        <template> 
          {{ quote.QuoteAssignedTo ? quote.QuoteAssignedTo.fullName : 'Not Assigned' }} <br/>
          <span class="text-muted">{{ dateAssigned }}</span>
        </template>
      </td>
      <!-- Buttons for Grant Access Column-->
      <td data-label="Inspection Status">
        <!-- Access Status -->
        <template>
          <span :class="accessStatus.class"><i :class="accessStatus.icon"/>{{ accessStatus.text }}</span>
        </template>
        <!-- Edit Access -->
        <template v-if="this.$user.administrator">
          <span class="badge badge-pill badge-warning" style="cursor: pointer;" @click="scheduleQuoteAccess()"><i class="fa fa-edit"/>Edit</span>
        </template>
        <!-- Info Pill -->
        <template v-if="accessStatus.value">
          <span class="badge badge-pill badge-info" style="cursor: pointer;" @click="viewQuoteAccess()"><i class="fas fa-fw fa-info"/>Info</span>
        </template>
        <!-- Access Dates -->
        <!-- <template v-if="quote.accessStartDate && !inspectionStatus.value">
            <span class="text-muted">{{ dateAccessStart }} - </span>
          </template>
          <template v-if="quote.accessEndDate && !inspectionStatus.value">
            <span class="text-muted">{{ dateAccessEnd }}</span>
          </template> -->
        <!-- Access Buttons -->
        <!-- <template v-if="!accessStatus.value && !inspectionStatus.value && (this.$user.administrator)">
          <button
            class="my-1 btn btn-trello"
            @click="scheduleQuoteAccess()">
            <i class="fa fa-unlock fa-fw" /> Access Time
          </button>
          <button
            class="my-1 btn btn-primary"
            @click="grantAccessQuote()">
            <i class="fa fa-unlock fa-fw" /> Open Access
          </button>
        </template> -->

        <hr>
        <!-- Inspection Status -->
        <template>
          <span :class="inspectionStatus.class"><i :class="inspectionStatus.icon"/>{{ inspectionStatus.text }}</span>
        </template>
        <!-- Edit Inspection -->
        <template>
          <span class="badge badge-pill badge-warning" style="cursor: pointer;" @click="editInspectionTimes()"><i class="fa fa-edit"/>Edit</span>
        </template>
        <!-- Info Pill -->
        <template v-if="accessStatus.value">
          <span class="badge badge-pill badge-info" style="cursor: pointer;" @click="viewInspectionTimes()"><i class="fas fa-fw fa-info"/>Info</span>
        </template>

        <br>

        <!-- <template v-if="accessStatus.value && quote.inspectionStartDate">
            <span class="text-muted">{{ dateInspectionStart }}</span>
            <span class="text-muted mx-1">-</span>
        </template> -->
        <!-- Button to start inspection -->
        <!-- <template v-else>
          <button
            class="my-1 btn btn-primary"
            @click="startInspection()"
            :disabled="!accessStatus.value">
            <i class="far fa-clock fa-fw" /> Inspection Start
          </button>
        </template> -->
        <!-- <template v-if="accessStatus.value && quote.inspectionEndDate">
          <span class="text-muted">{{ dateInspectionEnd }}</span>
        </template> -->

        <!-- Button to start inspection -->
        <!-- <template v-else>
          <button
            class="my-1 btn btn-secondary"
            :disabled="!accessStatus.value"
            @click="endInspection()">
            <i class="far fa-clock fa-fw" /> Inspection End
          </button>
        </template> -->
      </td>
      <td v-if="quote.Company" data-label="Quoted Sum">
        {{ (quote.Company.serviceProviderPercent > 0) ? quote.actualCost * (1 + 0.01 * parseFloat(quote.Company.serviceProviderPercent)) 
            : (quote.Company.serviceProviderAmount > 0) ? quote.actualCost + parseFloat(quote.Company.serviceProviderAmount)
            : quote.actualCost | toDollarAmount }}
      </td>
      <td v-else data-label="Quoted Sum">
        {{ quote.actualCost | toDollarAmount }}
      </td>
      <td class="button-2 text-center">
        <router-link
          :to="{ path: 'quotes/notes/' + quote.uuid }"
          :class="quote.QuoteNotes.length > 0 ? 'my-1 btn btn-success' : 'my-1 btn btn-secondary'">
          <i class="fa fa-sticky-note" /> Notes
        </router-link>
        <button v-if="quote.QuotePdf"
          class="my-1 btn btn-success"
          @click="download()">
          <i class="fa fa-download" /> Download Quote
        </button>
        <router-link v-if="quote.QuotePdf"
          target="_blank"
          :to="{ path: '/api/public/pdf/' + quote.uuid + '?m=Quote' }"
          class="my-1 btn btn-info">
          <i class="fa fa-fw fa-search" /> Preview Quote
        </router-link>
        <button
          class="my-1 btn btn-trello"
          @click="trelloAttachments()">
          <i class="fab fa-trello" /> Trello Attachments
        </button>
        <button
          class="my-1 btn btn-warning"
          @click="systemAttachments()">
          <i class="fa fa-paperclip" /> System Attachments
        </button>
        <router-link
          :to="'/tax-invoice-requests/new/' + quote.uuid + '?t=Quote'"
          class="my-1 btn btn-warning"
          :class="{ 'disabled': !generateInvoiceButton }">
          <i class="fa fa-fw fa-dollar-sign" /> Invoice Request
        </router-link>
        <button
          @click="assignQuote()"
          class="my-1 btn btn-primary">
          <i class="fa fa-fw fa-id-badge" /> Assign Staff
        </button>
        <button
          @click="completeWorkOrder()"
          :hidden="quote.completed"
          class="my-1 btn btn-success">
          <i class="fas fa-clipboard-check" /> Complete Work
        </button>
        <button v-if="quote.completed"
          @click="uncompleteWorkOrder()"
          class="my-1 btn btn-danger">
          <i class="fas fa-file" /> Incomplete Work
        </button>
        <button
          @click="unacceptQuote()"
          class="my-1 btn btn-danger">
          <i class="fas fa-times" /> Cancel Work Order
        </button>
      </td>
      <form action="/api/admin/form/download" method="post" ref="form">
        <input type="hidden" name="token" v-model="token">
        <input type="hidden" name="permalink" value="downloadQuote">
        <input type="hidden" name="data" :value="formData">
      </form>
    </tr>

</template>

<script>
  import {
    ASSIGN_QUOTE,
    COMPLETE_WORK_ORDER,
    UNCOMPLETE_WORK_ORDER,
    GET_QUOTE_TRELLO_ATTACHMENTS,
    GET_QUOTE_ATTACHMENTS,
    UNACCEPT_QUOTE,
    VIEW_INSPECTION_TIMES,
    EDIT_INSPECTION_TIMES,
    SCHEDULE_QUOTE_ACCESS,
    VIEW_QUOTE_ACCESS,
  } from '@/vuex/types'
  export default {
    name: 'AcceptedQuoteRow',
    props: {
      object: {
        type: Object
      },
      onClick: {
        type: Function
      },
      selectedRow: {
        type: String,
        default: ''
      }
    },
    computed: {
      formData () {
        return JSON.stringify({ quoteUuid: this.quote.uuid })
      },
      status () {
        let status = {}
        if (this.quote.completed) {
          status.class = 'badge badge-pill badge-success'
          status.text = 'Completed'
        } else {
          status.class = 'badge badge-pill badge-warning'
          status.text = 'In Progress'
        }
        return status
      },
      assignedStatus () {
        let status = {}
        if (this.quote.isQuoteAssigned) {
          status.class = 'badge badge-pill badge-primary'
          status.text = 'Assigned'
        } else {
          status.class = 'badge badge-pill badge-danger'
          status.text = 'Not Assigned'
        }
        return status
      },
      inspectionStatus () {
        let status = {}
        status.icon = 'fa fa-search fa-fw'
        if (this.quote.inspectionStartDate && this.quote.inspectionEndDate) {
          status.class = 'badge badge-pill badge-success'
          status.text = 'Inspected'
          status.value = true
        }
        else if(this.quote.inspectionStartDate || this.quote.inspectionEndDate) {
          status.class = 'badge badge-pill badge-warning'
          status.text = 'In Progress'
          status.value = true
        }
        else {
          status.class = 'badge badge-pill badge-danger'
          status.text = 'Not Inspected'
          status.value = false
        }
        return status
      },
      accessStatus () {
        let status = {}
        if (this.quote.accessGranted && (this.quote.accessStartDate || this.quote.accessEndDate)) {
          status.class = 'badge badge-pill badge-success'
          status.text = 'Access Granted'
          status.icon = 'fa fa-unlock fa-fw'
          status.value = true
        } else if(this.quote.accessGranted){
          status.class = 'badge badge-pill badge-success'
          status.text = 'Open Access'
          status.icon = 'fa fa-unlock fa-fw'
          status.value = true
        } else {
          status.class = 'badge badge-pill badge-danger'
          status.text = 'No Access'
          status.icon = 'fa fa-lock fa-fw'
          status.value = false
        }
        return status
      },
      generateInvoiceButton () {
        return !this.quote.TaxInvoiceRequestUuid
      },
      dateRequested () {
        return moment(this.quote.createdAt).format('dddd Do of MMMM YYYY hh:mm A')
      },
      dateSent () {
        return moment(this.quote.sentDate).format('dddd Do of MMMM YYYY hh:mm A')
      },
      dateAccepted () {
        return moment(this.quote.acceptedDate).format('dddd Do of MMMM YYYY hh:mm A')
      },
      dateAccessStart () {
        return moment(this.quote.accessStartDate).format('dddd Do of MMMM YYYY hh:mm A')
      },
      dateAccessEnd () {
        return moment(this.quote.accessEndDate).format('dddd Do of MMMM YYYY hh:mm A')
      },
      dateInspectionStart () {
        return moment(this.quote.inspectionStartDate).format('dddd Do of MMMM YYYY hh:mm A')
      },
      dateInspectionEnd () {
        return moment(this.quote.inspectionEndDate).format('dddd Do of MMMM YYYY hh:mm A')
      },
      dateAssigned () {
        return this.quote.assignedDate ? moment(this.quote.assignedDate).format('dddd Do of MMMM YYYY hh:mm A') : null
      },
      completedDate () {
        return this.quote.completedDate ? moment(this.quote.completedDate).format('dddd Do of MMMM YYYY hh:mm A') : null
      },
      quote () {
        return {
          ...this.object
        }
      }
    },
    data () {
      return {
        token: ''
      }
    },
    methods: {
      async assignQuote () {
        await this.$store.dispatch(ASSIGN_QUOTE, this.quote.uuid)
      },
      async unacceptQuote () {
        await this.$store.dispatch(UNACCEPT_QUOTE, this.quote.uuid)
      },
      async completeWorkOrder () {
        await this.$store.dispatch(COMPLETE_WORK_ORDER, this.quote.uuid)
      },
      async uncompleteWorkOrder () {
        await this.$store.dispatch(UNCOMPLETE_WORK_ORDER, this.quote.uuid)
      },
      // async startInspection () {
      //   await this.$store.dispatch(START_INSPECTION, this.quote.uuid)
      // },
      // async endInspection () {
      //   await this.$store.dispatch(END_INSPECTION, this.quote.uuid)
      // },
      async editInspectionTimes () {
        await this.$store.dispatch(EDIT_INSPECTION_TIMES, this.quote.uuid)
      },
      async viewInspectionTimes () {
        await this.$store.dispatch(VIEW_INSPECTION_TIMES, this.quote.uuid)
      },
      async viewQuoteAccess () {
        await this.$store.dispatch(VIEW_QUOTE_ACCESS, this.quote.uuid)
      },
      async scheduleQuoteAccess () {
        await this.$store.dispatch(SCHEDULE_QUOTE_ACCESS, this.quote.uuid)
      },
      async download () {
        this.token = window.sessionStorage.getItem('token')
        await this.$nextTick()
        this.$refs.form.submit()
      },
      async trelloAttachments () {
        await this.$store.dispatch(GET_QUOTE_TRELLO_ATTACHMENTS, this.quote.uuid)
      },
      async systemAttachments () {
        await this.$store.dispatch(GET_QUOTE_ATTACHMENTS, this.quote.uuid)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/rows/AcceptedQuote.vue